import Vue from "vue";

import PhysicalPurchases from "./PhysicalPurchases.vue";

export function load() {
    const selector = "physical-purchases";

  // Is the custom Vue root element in the DOM?
  if (!document.querySelector(selector)) {
    return;
  }

  // Create a new Vue app with the imported Home component
  new Vue({
    render: createElement =>
      createElement(PhysicalPurchases, {
        props: {
          ...window[selector],
        },
      }),
  }).$mount(selector);
}
